var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:_vm.LOCALE},[_c('div',{staticClass:"btns"},[_c('span',{staticClass:"join",on:{"click":_vm.join}},[_vm._v(" "+_vm._s(_vm.$t('nowJoin'))+" ")]),_c('span',{staticClass:"view",on:{"click":_vm.view}},[_vm._v(" "+_vm._s(_vm.$t('viewRanking'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }